import type { UiPreferences } from "../prefs/useUiPreferences";

/** Datenmigration gespeicherter Ziele; diese Altrouten werden nicht mehr registriert. */
export function normalizeStoredNavigationPath(path: string): string {
  const splitAt = path.search(/[?#]/);
  const pathname = splitAt < 0 ? path : path.slice(0, splitAt);
  const suffix = splitAt < 0 ? "" : path.slice(splitAt);
  const moved: Record<string, string> = {
    "/dashboard": "/overview",
    "/admin/dashboard": "/admin",
    "/settings/default-theme": "/settings/general",
  };
  return (moved[pathname] ?? pathname) + suffix;
}

export function normalizeStoredNavigationTargets(prefs: UiPreferences): UiPreferences {
  const start = prefs.startPage?.path;
  const pins = prefs.pinnedLinks?.items;
  return {
    ...prefs,
    ...(start ? { startPage: { ...prefs.startPage, path: normalizeStoredNavigationPath(start) } } : {}),
    ...(pins ? { pinnedLinks: { ...prefs.pinnedLinks, items: [...new Map(pins.map(pin => {
      const path = normalizeStoredNavigationPath(pin.path);
      const next = pin.kind === "route" ? { ...pin, path, id: `route:${path}` } : pin;
      return [next.id, next] as const;
    })).values()] } } : {}),
  };
}
